import * as React from "react";

import { IForm } from "../Engine/Form/IForm";

import { useFormObject } from "./FormObjectProvider";
import { extractNameFromComponent } from "./TypingUtils";

export interface FormObjectInjectableProps {
    form: IForm;
}

export function withFormObject<P extends FormObjectInjectableProps>(
    WrappedComponent: React.ComponentType<P>
): React.ComponentType<Omit<P, keyof FormObjectInjectableProps>> {
    function WithFormObject(props: Omit<P, keyof FormObjectInjectableProps>): JSX.Element {
        const form = useFormObject();

        // @ts-ignore Ну нехочет typescript работать с HOC-ами
        return <WrappedComponent {...props} form={form} />;
    }

    WithFormObject.displayName = `withFormObject(${extractNameFromComponent(WrappedComponent)})`;

    return WithFormObject;
}
